import $ from 'jquery';
import { getVh, getWindowWidth, getScrollBarWidth, debounce, pxToRem } from './functions';

const $window = $(window);
const $root = $(':root');

injectProps();
bindInject();

function bindInject() {
    $window.on('resize:width', injectWindowProps);
    $window.on('resize:height', injectSizeProps);
    $window.on(
        'resize',
        debounce(function () {
            injectScrollBarProps();
        })
    );
}

function injectProps() {
    injectSizeProps();
    injectWindowProps();
    injectScrollBarProps();
}

function injectSizeProps() {
    $root.css('--vh', pxToRem(getVh()));
}
function injectWindowProps() {
    $root.css('--window-width', pxToRem(getWindowWidth()));
}
function injectScrollBarProps() {
    $root.css('--scrollbar-width', pxToRem(getScrollBarWidth()));
}
